<template>
  <v-form @submit.prevent="$emit('save', award)">
    <v-card>
      <v-card-title>
        {{ $t('edit_award') }}
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="award.year"
              :error-messages="errors['year']"
              :label="formMixin_getRequiredFieldLabel($t('year'))"
              name="year"
              autofocus
              type="number"
              @input="formMixin_clearErrors('year')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-checkbox
              v-model="award.is_published"
              :error-messages="errors['is_published']"
              :label="$t('published')"
              @change="formMixin_clearErrors('is_published')"
            />
          </v-col>

          <v-col col="12">
            <BaseTextEditor
              v-model="award.description"
              :error-messages="errors['description']"
              :label="formMixin_getRequiredFieldLabel($t('description'))"
              name="description"
              @input="formMixin_clearErrors('description')"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <span class="text-subtitle-2 ml-3"> * {{ $t('must_be_filled') }} </span>

        <v-spacer />

        <v-btn text color="secondary" @click="$emit('preview', award)">{{ $t('preview') }}</v-btn>

        <v-btn text color="primary" @click="$emit('cancel')">{{ $t('cancel') }}</v-btn>

        <v-btn :disabled="disabled" :loading="disabled" color="primary" text type="submit">
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import formMixin from '../mixins/form-mixin';
import BaseTextEditor from './base/BaseTextEditor';

export default {
  name: 'AwardForm',

  components: { BaseTextEditor },

  mixins: [formMixin],

  props: {
    award: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
